<div id="outer">
  <app-header bare="true"></app-header>
  <div id="inner">
    <div id="content">
      <h2><span i18n>We sent you an email</span></h2>
      <p>
        <span i18n
          >Please click the link in the email to verify your email address. It
          will take you to a screen where you can begin enrollment.</span
        >
      </p>
      <p>
        <span i18n
          >If you clicked the verify link from a different device, click the
          button below to begin enrollment.</span
        >
      </p>
      <button mat-flat-button (click)="verify()" [disabled]="loading()">
        <span i18n="button label">Recheck and enroll</span>
      </button>
      <p></p>
      <p><span i18n>Don't see the email?</span></p>
      <button mat-flat-button (click)="resend()" [disabled]="loading()">
        <span i18n="button label">Resend verification</span>
      </button>
    </div>
  </div>
</div>
